import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { from, map, Observable, switchMap } from 'rxjs';
import {
  ImportBody,
  InlineResponse20010
} from '@app/shared/interfaces';
import { API_BASE } from '../../constants/general.constants';
import { APP_STATE_SERVICE } from '../app-state/app-state.service';

@Injectable({
  providedIn: 'root'
})
export class ImportService {
  private readonly http = inject(HttpClient);

  readonly #appState = inject(APP_STATE_SERVICE);

  /**
   * Import a project
   * @param importData The import data including file and JSON configuration
   */
  importProject(importData: ImportBody): Observable<InlineResponse20010> {
    // Create a FormData object to handle the multipart/form-data request
    const formData = new FormData();

    // Add the JSON configuration with proper Content-Type
    if (importData.json) {
      // Create a Blob with the correct Content-Type for the JSON field
      const jsonString = JSON.stringify(importData.json);
      const jsonBlob = new Blob([jsonString], { type: 'application/json' });
      formData.append('json', jsonBlob);
    }

    // Add the file
    if (importData.file) {
      formData.append('file', importData.file);
    }

    return this.http.post<InlineResponse20010>(`${API_BASE}/import`, formData).pipe(
      switchMap(response => {
        // Reload projects in AppState after successful import
        return from(this.#appState.loadProjects()).pipe(
          map(() => response)
        );
      })
    );
  }
}
